import api from "../client"
import { OrderOrderTemplateCreateResponseData } from "../types/order"

export const orderOrderTemplateCreateRequest = async (uuid: string | undefined) => {
    const { data } = await api.post<OrderOrderTemplateCreateResponseData>(
        `/orders/${uuid}/template`,
        {}
    )

    return data
}
